module.exports = __webpack_public_path__ + "static/media/millennial_club.dceee091.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/millennial_club.png
// module id = 8454
// module chunks = 0